import { AxiosError } from 'axios'

import { assertHasDotAtEnd } from 'utils/strings'

function nestedError(value: unknown): string {
  const error = value as string | string[]
  if (Array.isArray(error))
    return error
      .map((msg: string | { message: string }) => {
        const errorMsg =
          typeof msg === 'string'
            ? msg
            : Array.isArray(msg)
            ? msg[0]
            : msg.message
        return assertHasDotAtEnd(errorMsg)
      })
      .join(' ')
  return assertHasDotAtEnd(error)
}

export function parseError(error: AxiosError) {
  let errorMsg = 'Please check your network connection.'
  if (error?.response?.data) {
    errorMsg = Object.values(error.response?.data).map(nestedError).join(' ')
  }

  return assertHasDotAtEnd(errorMsg)
}
